export const locale = {
  lang: 'de',
  data: {
    LANGUAGE: {
      CHINESE: "Chinesisch",
      GERMAN: "Deutsch",
      ENGLISH: "Englisch",
      SPANISH: "Spanisch",
      FRENCH: "Französisch",
      ITALIAN: "Italienisch",
      DUTCH: "Niederländisch",
      POLISH: "Polieren",
      PORTUGUESE: "Portugiesisch",
      RUSSIAN: "Russisch"
    },
    DROPDOWN: {
      // ACCOUNT: "",
      // LOGOUT: ""
    }
  }
}